// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// import { concat } from "rxjs-compat/operator/concat";

// export const home_server = 'https://stgtuvidadigital.keepitsimple.com.mx';

export const environment = {
  production: false,

  // For staging
  url: 'https://stgtuvidadigital.keepitsimple.com.mx:80/api-tracer/api-tracer',
  urlLocal: 'https://stgtuvidadigital.keepitsimple.com.mx:443/',
  url3: 'https://stgtuvidadigital.keepitsimple.com.mx:80/api-tracer/api-tracer',
  url2: 'https://stgtuvidadigital.keepitsimple.com.mx:80/api-tracer/api-tracer',
  mifiel_url: 'http://app-sandbox.mifiel.com',  



};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
